module.exports = __webpack_public_path__ + "static/media/main.b5c543ce.svg";